module.exports = __webpack_public_path__ + "img/hovered-layer2.525ed7dc.png";